import { Injectable } from '@angular/core';
import { DetailedEntityBackendService } from 'app/shared/services/searchable-entity/detailed-entity/detailed-entity-backend.service';
import { Observable } from 'rxjs';

@Injectable()
export class SerialNumberPopupBackendService extends DetailedEntityBackendService {
  saveEntityforUpdate(requestItems: any) {
    const response$ = this.http$.put(`api/setup/`, JSON.stringify(requestItems))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
      });
    return response$;
  }

  getStorerConfig(storer: string): Observable<any> {
    return this.http$.get(`api/core/storer-config/${storer}/RCPTSNLOG`)
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.errors.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors[0].validationMessage);
          }
        }
      });
  }
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/serial-number-popup/services/serial-number-popup-backend.service.ts